import React from "react";
import {
  GSActionBar,
  GSPageSection,
  defaultPadding,
} from "golfstatus_react_components";

const PageHeader = (props) => {
  const { header, actions, style } = props;
  return (
    <GSPageSection
      style={{
        ...defaultPadding.noPad.apply("vertical"),
        ...style,
      }}
      bodyStyle={{ ...defaultPadding.noPad, overflow: "visible" }}
      body={[
        <GSActionBar
          style={defaultPadding.xLargePad.apply("vertical")}
          pageActions={actions}
          type="H1"
          header={header}
        />,
      ]}
    />
  );
};

export default PageHeader;
